<template>
    <div id="main">
        <div class="page">
            <loader v-if="isLoading" />
            <alert-container :messages="msgs" />
            <div class="listing-header mb-2">
                <div class="title-breadcrumb">
                    <h1 class="title"> {{ title }} </h1>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="onFecharModal">
                        {{ $t('voltar') }}
                    </button>
                </div>
            </div>
            <div class="align-img">
                <img :src="img" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
// COMPONENTS


export default {
    props: {
        img: null,
        typeCheck: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isLoading: false,
            isEmpty: false,
            msgs: [],
            title: '',
        };
    },
    created() {
        this.title = this.$t('foto-n', { n: this.$t(this.typeCheck) });
    },
    methods: {
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    min-height: 500px;
    padding: 17px 15px;
    border-radius: 5px;
}
.align-img {
    text-align: center;
}
</style>
